<script setup lang="ts">
type Props = {
  as?: string | object
  class?: string | object
}

const props = withDefaults(defineProps<Props>(), {
  as: 'div',
  class: undefined,
})

const classes = computed(() => ({
  'app-paper': true,
  [`${props.class}`]: !!props.class,
}))
</script>

<template>
  <component :is="as" :class="classes"><slot></slot></component>
</template>
